const LEVELS = [
  { label: "Debole", cls: "bg-rose-500", text: "text-rose-600" },
  { label: "Media", cls: "bg-amber-500", text: "text-amber-600" },
  { label: "Forte", cls: "bg-emerald-500", text: "text-emerald-600" },
];

export const passwordScore = (p) => {
  if (!p || p.length < 8) return 0;
  const kinds = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((r) => r.test(p)).length;
  if (p.length >= 12 && kinds >= 3) return 2;
  if (kinds >= 3 || (p.length >= 10 && kinds >= 2)) return 1;
  return 0;
};

export const PasswordStrength = ({ value, dark = false }) => {
  if (!value) return null;
  const s = passwordScore(value);
  const lv = LEVELS[s];
  return (
    <div className="mt-1.5" data-testid="password-strength">
      <div className="flex gap-1">
        {LEVELS.map((l, i) => <div key={l.label} className={`h-1 flex-1 rounded-full transition-colors ${i <= s ? lv.cls : dark ? "bg-slate-800" : "bg-slate-200"}`} />)}
      </div>
      <div className="mt-1 flex justify-between text-[11px]">
        <span className={`font-medium ${lv.text}`} data-testid="password-strength-label">Password {lv.label.toLowerCase()}</span>
        {s < 2 && <span className={dark ? "text-slate-500" : "text-slate-400"}>Usa 12+ caratteri con maiuscole, numeri e simboli</span>}
      </div>
    </div>
  );
};
